import Collapsible from 'common/components/collapsible/Collapsible';
import React from 'react';
import { useLocation } from 'react-router';

const HouseShareFaq = () => {
  return (
    <>
      <h1 className='mb-3'>Frequently Asked Questions</h1>
      <h3 className='mb-5'>Click on a category to expand.</h3>
      <div>
        <FaqCollapsible
          hash='#registration-numbers'
          title='Registration Numbers'
        >
          <div>
            <b>What is a Shared Housing Registration Number?</b>
            <p>
              Shared Housing Units are regulated by Registration Numbers. Each
              Shared Housing Unit listed on an internet based intermediary
              platform must have an approved Registration Number in order to be
              in compliance with the Shared Housing Ordinance. Operating a
              Shared Housing Unit without an approved Registration Number is
              noncompliant and may result in fines and citations.
            </p>
          </div>
          <div>
            <b>How do I apply for a Registration Number?</b>
            <p>
              Visit the Shared Housing Registration Portal at{' '}
              <a
                href='https://webapps1.chicago.gov/chicagohouseshare/'
                target='_blank'
                rel='noreferrer'
              >
                https://webapps1.chicago.gov/chicagohouseshare/
              </a>{' '}
              to create a Shared Housing account and submit an application for a
              Registration Number. All applications must be submitted through
              the portal.
            </p>
          </div>
          <div>
            <b>How much does a Registration Number cost?</b>
            <p>
              Upon approval, the applicant will be notified of their $125
              registration fee, which is paid on the Shared Housing Registration
              Portal. Registration Numbers are valid for one year, and must be
              renewed annually. Upon approved renewal, the host will have to pay
              the $125 registration fee each year.
            </p>
          </div>
          <div>
            <b>
              What are some of the eligibility requirements to be approved for a
              Registration Number?
            </b>
            <p>
              <ul>
                <li>
                  {' '}
                  Must be a dwelling unit with six or fewer sleeping rooms
                </li>
                <li>
                  {' '}
                  Not in a restricted residential zone (RRZ), Prohibited
                  Buildings List (PBL), Scofflaw List, Problem Landlord list
                  (PLL){' '}
                </li>
                <li>
                  {' '}
                  Cannot list housing units if rental agreement or HOA prohibit
                  short term shared housing
                </li>
                <li>
                  {' '}
                  Maximum rentals and primary residency per building are
                  determined by the following:{' '}
                </li>
                <br></br>
                <table className='table houseshare'>
                  <tr>
                    <th>SINGLE FAMILY HOME</th>
                    <th>BUILDING WITH 2-4 UNITS </th>
                    <th>BUILDING WITH 5+ UNITS</th>
                  </tr>
                  <tr>
                    <td width='150px'>Unit must be Primary Residence</td>
                    <td width='150px'>Unit must be Primary Residence</td>
                    <td width='150px'>
                      Unit does not need to be Primary Residence
                    </td>
                  </tr>
                  <tr>
                    <td>Maximum 1 active rental</td>
                    <td>Maximum 1 active rental</td>
                    <td>
                      Maximum of one-quarter of total number of dwelling units
                      or 6 rental units, whichever is less.
                    </td>
                  </tr>
                </table>
              </ul>
            </p>
          </div>
          <div>
            <b>
              I’ve been approved for a Registration Number. What do I do now?
            </b>
            <p>
              After the host has made the registration fee payment, a
              Registration Number will be issued. The host must include their
              Registration Number in the specified field on the intermediary
              platform’s website. The Registration Number must be visible in
              their listing to be in compliance.
            </p>
          </div>
          <div>
            <b>I’ve been denied for a Registration Number. What do I do now?</b>
            <p>
              The reason for denial will be included in the denial communication
              sent to the host. The host can appeal the decision within 10
              calendar days of the date listed on their denial notice.
            </p>
          </div>
        </FaqCollapsible>

        <FaqCollapsible
          hash='#SHOUL'
          title='Shared Housing Unit  Operator License'
        >
          <div>
            <b>What is a Shared Housing Unit Operator?</b>
            <p>
              A “Shared Housing Unit Operator” is an owner or operator of two or
              more shared housing units that are rented to guests through an
              internet based intermediary platform.
            </p>
          </div>
          <div>
            <b>
              Who needs to obtain a Shared Housing Unit Operator License
              (SHUOL)?
            </b>
            <p>
              Any host who is operating (or intending to operate) more than one
              shared housing unit, should obtain the SHUOL. In other words, a
              host who has two or more shared housing registration numbers,
              should have the SHUOL. If a shared housing host only has one
              registration number, then this license is not necessary.
            </p>
          </div>
          <div>
            <b>
              What is the difference between a SHUOL and a Shared Housing
              Registration Number?
            </b>
            <p>
              The SHUOL licenses the operator in the business activity of
              operating more than one shared housing unit. The operator only
              needs one of these licenses. A Shared Housing Registration Number
              is issued for each approved shared housing unit which allows the
              registered unit to be listed on an internet based intermediary
              platform. Each shared housing unit requires its own approved
              registration number.
            </p>
          </div>
          <div>
            <b>
              Once I’m licensed, can I list any of my units on an internet based
              intermediary platform?
            </b>
            <p>
              The SHUOL only allows the operator to obtain more than one shared
              housing registration number. This license is not approval to list
              a shared housing unit on an internet based intermediary platform.
              The operator would need an approved shared housing registration
              number to be permitted to list on an internet based intermediary
              platform.
            </p>
          </div>
          <div>
            <b>Where do I apply for the SHUOL?</b>
            <p>
              You can apply online at{' '}
              <a
                href='https://webapps1.chicago.gov/AccountServices/login.jsp'
                target='_blank'
                rel='noreferrer'
              >
                https://webapps1.chicago.gov/AccountServices/login.jsp
              </a>{' '}
              (Chicago Business Direct), or you can visit Chicago City Hall (121
              N LaSalle St, room 800) and meet with a Business Consultant to
              apply.
            </p>
          </div>
          <div>
            <b>When should I apply for the SHUOL?</b>
            <p>
              Shared Housing hosts should apply for the SHUOL before they apply
              for their second Shared Housing Registration Number. Without
              obtaining the SHUOL prior to applying for their second Shared
              Housing registration Number, their application may be rejected.
            </p>
          </div>
          <div>
            <b>How much does the SHUOL cost?</b>
            <p>
              The SHUOL cost $250 and is good for 2 years. Renewal is required
              every two years to keep the license active.
            </p>
          </div>
          {/*<div>
            <b>What is a Shared Housing Unit Operator?</b>
            <p>
              A Shared Housing Unit Operator (SHUO) is any person who has
              registered, or who is required to register, as the shared housing
              host of more than one shared housing unit.
            </p>
          </div>
          <div>
            <b> {/* nothing under here is needed 
              How do I apply for a short-term shared housing registration and
              what supporting documents are required?
            </b>
            <p>
              Our{' '}
              <Link
                to='help/applyingForRegistration'
                target='_blank'
                rel='noreferrer'
              >
                How-to Guide
              </Link>{' '}
              will walk you through all the steps required as part of this
              process.{' '}
            </p>
          </div>
          <div>
            <b>
              What happens if my application is approved for a Shared Housing
              Registration? Is there a registration fee?{' '}
            </b>
            <p>
              Once an application is submitted, it will be reviewed for
              eligibility. If the application is deemed eligible, the host will
              be notified that their application is approved, pending a $125
              registration fee. Once payment is received, BACP will issue a
              registration number and release the unit to be listed on a
              licensed intermediary platform. Hosts can track progress of their
              application via the short-term shared housing portal.
            </p>
          </div>
          <div>
            <b>
              Can I list my shared housing unit on an intermediary platform
              while my application is pending?
            </b>
            <p>
              No, listing a shared housing unit on any platform without an
              approved registration number is prohibited.
            </p>
          </div>
          <div>
            <b>
              Can I list my property on multiple intermediaries? Does the price
              change if I list on more than one?
            </b>
            <p>
              This will result in 2 different applications being sent. However,
              when approved you only need to pay for 1 registration number for
              both.
            </p>
          </div>
          <div>
            <b>Can I list my place as a partial unit listing?</b>
            <p>
              Listings are either full or partial. A host may decide to do
              either or they may do both. Each partial listing will result in
              its own application. Since partial listings are within the same
              unit, a host will be able to use the same registration number
              provided when the initial unit was approved.
            </p>
          </div>
        </FaqCollapsible>

        <FaqCollapsible
          hash='#i-am-a-shared-housing-host'
          title='I am a Shared Housing Host'
        >
          <div>
            <b>
              How do I know if a platform is licensed with the City of Chicago?
            </b>
            <p>
              All licensed short term residential rental intermediary‘s and/or
              short term residential rental advertising platforms are listed in
              the City of Chicago’s Data Portal at{' '}
              <a
                href='https://data.cityofchicago.org/'
                target='_blank'
                rel='noreferrer'
              >
                https://data.cityofchicago.org/
              </a>
              . Be sure the platform you select is properly licensed.
            </p>
          </div>
          <div>
            <b>Can I remove my listing from a shared housing platform?</b>
            <p>
              Yes. In order to remove your listing, you must first request to do
              so through the shared housing platform in which your listing is
              active. Once you have completed this process, contact BACP to
              complete the final steps of this process.{' '}
            </p>
          </div>
          <div>
            <b>
              I already have a registration number for my shared housing unit
              that was approved before June 1, 2021. How do I renew my
              registration?
            </b>
            <p>
              When it comes time to renew your registration, you will need to
              create an account to do so. However you can also create an account
              now that you will then use to renew your registration when it
              comes due.
            </p>
          </div>
          <div>
            <b>How will the renewal process work in the new system?</b>
            <p>
              Renewals will be done through the short-term shared housing portal
              if registration was applied for after June 1, 2021. Notification
              for renewal will be sent out by BACP. The annual $125 fee per
              approved registration will due at this time as well.
            </p>
          </div>
          <div>
            <b>Can I make a change to my application?</b>
            <p>
              You can change your email address on your application. However, in
              order to change your first or last name, please contact BACP for
              additional assistance. You will need to provide documentation as
              part of this request.
            </p>
          </div>
          <div>
            <b>
              I provided my registration number to the shared housing platform.
              What happens next?
            </b>
            <p>
              Once you have provided your registration number, no further action
              is required. The shared housing platform is required to provide a
              listing ID and URL on your behalf. This information is required in
              order for the listing to be considered compliant with the shared
              housing ordinance.{' '}
            </p>
          </div>
          <div>
            <b>Can I withdraw my shared housing application?</b>
            <p>
              If this option is available to you within the portal, you still
              have time to withdraw your application. Once this option
              disappears from the portal, you can no longer do so.
            </p>
          </div>
          <div>
            <b>Can I deactivate my account?</b>
            <p>
              Yes, but you must remove all active applications and/or
              registrations in order to do so. Please note that deactivating
              your account removes all prior information and you must start the
              process again in order to become a shared housing host.
            </p>
          </div>
          <div>
            <b>
              What do I do if I've been denied for shared housing registration?
            </b>
            <p>
              BACP communicates the outcome of shared housing registration
              applications. The response to the application will provide
              instructions on any/all appeal options.
            </p>
          </div>
        </FaqCollapsible>

        <FaqCollapsible
          hash='#i-am-a-landlord-or-building-owner'
          title='I am a Landlord or Building Owner'
        >
          <div>
            <b>
              I am the owner of a building containing five or more dwelling
              units, and I want to prohibit short term rental activity in my
              building. What should I do?
            </b>
            <p>
              If you own a building containing five or more dwelling units, or
              the building is otherwise governed by a homeowners association,
              condo association, or building cooperative, you may complete,
              sign, and notarize an Affidavit for Inclusion in the Short-Term
              Rental Prohibited Buildings List which may be found at{' '}
              <a
                href='https://webapps1.cityofchicago.org/ProhibitedBuildingsRegistration/home'
                target='_blank'
                rel='noreferrer'
              >
                https://webapps1.cityofchicago.org/ProhibitedBuildingsRegistration/home
              </a>
              .
            </p>
            <p>
              If applicable, you may also include in residential rental
              agreements or lease agreements indicating that short term rental
              activity is prohibited in the building.
            </p>
          </div>
          <div>
            <b>
              My building is on the Prohibited Buildings List. How do I get it
              removed?
            </b>
            <p>
              An Affidavit for Removal must be submitted by the appropriately
              authorized individual in order for the building to be removed from
              the Prohibited Buildings List. To fill out the form, follow this
              link:{' '}
              <a
                href='https://webapps1.cityofchicago.org/ProhibitedBuildingsRegistration/home'
                target='_blank'
                rel='noreferrer'
              >
                https://webapps1.cityofchicago.org/ProhibitedBuildingsRegistration/home
              </a>
              .{' '}
            </p>
          </div>
          <div>
            <b>
              My building is on the Prohibited Buildings List, but short term
              rental activity is occurring in my building. What can I do?
            </b>
            <p>
              You can file a complaint by dialing 311. You may also file a
              Shared Housing Complaint Form here:{' '}
              <a
                href='https://www.chicago.gov/content/dam/city/depts/bacp/general/Vaca_Rental_BB_Shared_Housing_Complaint_Form-62117.pdf'
                target='_blank'
                rel='noreferrer'
              >
                https://www.chicago.gov/content/dam/city/depts/bacp/general/Vaca_Rental_BB_Shared_Housing_Complaint_Form-62117.pdf
              </a>
            </p>
          </div>*/}
        </FaqCollapsible>
      </div>
    </>
  );
};

type FaqCollabsibleProps = {
  /**
   * The key used to determine if the item is open by default based on the current location's hash.
   */
  hash: string;
  /**
   * Title displayed when item is collapsed.
   */
  title: string;
  children: React.ReactNode;
};

const FaqCollapsible = (props: FaqCollabsibleProps) => {
  const { hash } = useLocation();

  return (
    <Collapsible
      eventKey={props.hash}
      className='mb-5'
      leftHeaderContent={<h3>{props.title}</h3>}
      defaultOpen={hash === props.hash} // TODO based on path...
    >
      {props.children}
    </Collapsible>
  );
};

export default HouseShareFaq;
